import { Stack, Typography } from '@mui/material'
import React, { useMemo } from 'react'
import { useParams } from 'react-router-dom'

import PageSection, { ErrorSection } from 'components/common/PageSection'
import { ManageClusterAccessTeamsList } from 'components/configurations/clusters/manage-cluster-access/ManageClusterAccessTeamsList'
import { PendingNamespaceAccessRequestAlert } from 'components/configurations/common/PendingNamespaceAccessRequestAlert'
import { useManageSharedAssets } from 'hooks/use-manage-shared-assets'
import { messageFromResponseError } from 'utils/strings'

export const ManageClusterAccessPage: React.FC = () => {
  const { assetId } = useParams()

  const {
    isLoadingSharedAssets,
    isErrorSharedAssets,
    sharedAssetsError,
    getOwnedClusterById,
    getPendingIncomingRequestsForCluster
  } = useManageSharedAssets()

  const ownedCluster = useMemo(() => {
    if (!assetId) {
      return
    }

    return getOwnedClusterById(assetId)
  }, [assetId, getOwnedClusterById])

  return (
    <PageSection
      errorMessage={messageFromResponseError(
        sharedAssetsError,
        'We encountered an error while fetching Shared Assets. Please try again later.'
      )}
      hasError={isErrorSharedAssets}
      isLoading={isLoadingSharedAssets}
    >
      {() => {
        if (!ownedCluster) {
          return <ErrorSection message="Unable to find the selected cluster" />
        }

        const pendingIncomingRequests = getPendingIncomingRequestsForCluster(
          ownedCluster.assetId
        )

        return (
          // TODO: useFlexGap
          <Stack data-testid="manage-cluster-access-page" sx={{ rowGap: 4 }}>
            <Stack sx={{ rowGap: 2 }}>
              <Typography variant="h5">
                {ownedCluster.clusterName} management
              </Typography>
              <Typography>Manage team namespace access</Typography>
              {pendingIncomingRequests.length > 0 && (
                <PendingNamespaceAccessRequestAlert title="A team is waiting for namespace sharing approval" />
              )}
            </Stack>
            <ManageClusterAccessTeamsList cluster={ownedCluster} />
          </Stack>
        )
      }}
    </PageSection>
  )
}
